import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';

interface UseInheritPosIdProps {
  index: number;
  formReturn: Pick<UseFormReturn<any>, 'watch' | 'setValue' | 'getValues' | 'register' | 'trigger'>;
}

export const useInheritPosId = ({ index, formReturn }: UseInheritPosIdProps) => {
  const { watch, setValue, getValues, register, trigger } = formReturn;

  const inheritPosId = watch(`modifiers.${index}.inheritPosId`);

  useEffect(() => {
    if (inheritPosId) {
      setValue(`modifiers.${index}.posId`, '', { shouldValidate: true });
    } else {
      setValue(`modifiers.${index}.posId`, getValues(`modifiers.${index}.posId`) || '', { shouldValidate: true });
    }
  }, [inheritPosId, index, setValue, getValues]);

  const posIdRegisterOptions = register(`modifiers.${index}.posId`, {
    validate: (value, formValues) => {
      const inherit = formValues.modifiers?.[index]?.inheritPosId;
      return inherit || !!value?.trim() || 'Please enter a POS ID';
    },
    deps: [`modifiers.${index}.inheritPosId`],
    onChange: () => trigger(`modifiers.${index}.posId`),
    onBlur: (e) => {
      const trimmed = e.target.value?.trim() ?? '';
      if (trimmed !== e.target.value) {
        setValue(`modifiers.${index}.posId`, trimmed, { shouldValidate: true });
      }
    },
  });

  return {
    inheritPosId,
    posIdRegisterOptions,
  };
};
